// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"faee61b9","658":"22dfde1e"}[chunkId] + ".chunk.css";
};